import script from "./cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./cards.vue?vue&type=script&setup=true&lang=ts"

import "./cards.vue?vue&type=style&index=0&id=6ebd9a2b&lang=scss&scoped=true"
import "./cards.vue?vue&type=style&index=1&id=6ebd9a2b&lang=scss"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebd9a2b"]])

export default __exports__